import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Input from 'reactstrap/lib/Input';
import { IconMobileSearch } from 'components/icons/icon-mobile-search/icon-mobile-search';
import { IconSearchClose } from 'components/icons/icon-search-close/icon-search-close';
import { IconDesktopSearch } from 'components/icons/icon-desktop-search/icon-desktop-search';

export const GamesSearchInput = ({
  onChange,
  searchValue,
  clearSearchValue,
  isGamePage,
  className
}) => (
  <div className={classNames('position-relative search-input-wrapper', className, { 'px-2 py-1_25 pt-md-2 pb-md-0 mb-md-2': !isGamePage })}>
    <FormattedMessage id="games.search.search-games">
      {placeholder => (
        <Input
          onChange={onChange}
          value={searchValue}
          className={classNames('search-input pl-4 pl-md-8_5 border-1', { 'pr-4_5': searchValue })}
          placeholder={placeholder}
        />
      )}
    </FormattedMessage>

    <IconMobileSearch className="icon-search position-absolute d-md-none" />
    <IconDesktopSearch className="icon-search position-absolute d-none d-md-block" />
    <IconSearchClose onClick={clearSearchValue} className="icon-close position-absolute cursor-pointer" />
  </div>
);

GamesSearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  clearSearchValue: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  className: PropTypes.string,
  isGamePage: PropTypes.bool
};

GamesSearchInput.defaultProps = {
  className: '',
  isGamePage: false
};

